<template>
    <div
        class="min-h-screen flex flex-col bg-white md:bg-slate-50 px-4"
        :class="step === STEP_COMPLETE ? 'py-0 md:py-10' : 'py-6 md:py-10'"
    >
        <!-- Logo with mobile back button -->
        <div
            v-if="step !== STEP_COMPLETE"
            class="w-full flex items-center justify-center relative"
        >
            <button
                v-if="step > 0 && step !== STEP_PLAN"
                type="button"
                @click="prev"
                class="absolute left-0 md:hidden inline-flex items-center justify-center p-2 rounded text-slate-600"
                aria-label="Back"
            >
                <Icon icon="chevron-left" :width="20" :height="20" />
            </button>
            <img
                src="/images/logo.svg"
                alt="My10x"
                class="mb-0 md:mb-8"
                style="width: 110px; height: auto"
            />
        </div>

        <!-- Desktop logo on final step -->
        <div
            v-if="step === STEP_COMPLETE"
            class="w-full hidden md:flex items-center justify-center"
        >
            <img
                src="/images/logo.svg"
                alt="My10x"
                class="mb-8"
                style="width: 110px; height: auto"
            />
        </div>

        <div class="flex-1 w-full flex items-stretch md:items-center justify-start md:justify-center">
            <div
                :class="
                    step === STEP_PLAN
                        ? 'w-full md:w-[960px] flex flex-col items-stretch md:items-center gap-0 flex-1 md:flex-none'
                        : 'w-full md:w-[480px] bg-white md:rounded-2xl md:shadow p-0 md:px-10 md:pt-6 md:pb-12 flex flex-col items-stretch md:items-center gap-0 md:gap-16 flex-1 md:flex-none'
                "
            >
                <QuizProgressBar
                    v-if="step !== STEP_COMPLETE && step !== STEP_PLAN"
                    :step="step"
                    @back="prev"
                />

                <!-- Plan-step has its own header with Back link -->
                <div
                    v-if="step === STEP_PLAN"
                    class="w-full hidden md:flex items-center justify-between mb-2"
                >
                    <button
                        type="button"
                        @click="prev"
                        class="inline-flex items-center gap-2 rounded text-slate-600 text-sm font-medium"
                    >
                        <Icon icon="chevron-left-small" />
                        <span>Back</span>
                    </button>
                    <div></div>
                </div>

                <div class="w-full flex flex-col items-start">
                    <QuizStepAirports v-if="step === STEP_AIRPORTS" />
                    <QuizStepDestinations v-else-if="step === STEP_DESTINATIONS" />
                    <QuizStepBusinesses v-else-if="step === STEP_BUSINESS" />
                    <QuizStepPlan v-else-if="step === STEP_PLAN" />
                    <QuizStepSuccess v-else-if="step === STEP_COMPLETE" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Plain from '@/Layouts/Plain.vue';
import Icon from '@/components/ui/icon/icon.vue';
import QuizProgressBar from './Quiz/QuizProgressBar.vue';
import QuizStepAirports from './Quiz/QuizStepAirports.vue';
import QuizStepDestinations from './Quiz/QuizStepDestinations.vue';
import QuizStepBusinesses from './Quiz/QuizStepBusinesses.vue';
import QuizStepPlan from './Quiz/QuizStepPlan.vue';
import QuizStepSuccess from './Quiz/QuizStepSuccess.vue';
import {
    provideQuizWizard,
    STEP_AIRPORTS,
    STEP_DESTINATIONS,
    STEP_BUSINESS,
    STEP_PLAN,
    STEP_COMPLETE,
} from '@/composables/useQuizWizard';

defineOptions({ layout: Plain });

const props = defineProps({
    startStep: { type: Number, default: 0 },
    planVariant: { type: String, default: 'default' },
    products: { type: Array, default: () => [] },
    priorData: { type: Object, default: () => ({}) },
    skipPlanStep: { type: Boolean, default: false },
});

const { step, prev } = provideQuizWizard({
    startStep: props.startStep,
    planVariant: props.planVariant,
    products: props.products,
    priorData: props.priorData,
    skipPlanStep: props.skipPlanStep,
});
</script>
